// extracted by mini-css-extract-plugin
export default {"contactsIconsItem":"SocialIcon_contactsIconsItem__jWL8p","bgPulse":"SocialIcon_bgPulse__C0Q1o"};